<template>
    <div class="card-box" @click="toDetail">
        <div class="bg" v-if="dropdown">
            <div class="operation-content">
                <el-tooltip class="item" v-if="publish=='publish'" effect="dark" content="课程发布" placement="top-start">
                    <div @click.stop="$emit('publish',cardData)">
                        <img src="../../../assets/image/software/publish.png" alt="">
                    </div>
                </el-tooltip>
                <el-tooltip class="item" v-else-if="publish=='cancel'" effect="dark" content="取消发布" placement="top-start">
                    <div @click.stop="$emit('noPublish',cardData)">
                        <img src="../../../assets/image/software/publish.png" alt="">
                    </div>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="课程数据" placement="top-start">
                    <div @click.stop="$emit('courseInfo',cardData)">
                        <img src="../../../assets/image/software/data.png" alt="">
                    </div>
                </el-tooltip>
                <el-dropdown>
                    <div class="better-more" @click.stop>
                            <img src="../../../assets/image/software/more.png" alt="">
                    </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item,index) in dropdown" :key="index" @click.native="$emit(item.method,cardData)">{{ item.label }}</el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="no-start-label" :style="`background-color:${filterStatus(cardData.courseStatus)};`">{{ cardData.courseStatus }}</div>
        <img class="img-style" :src="cardData.coverImageUrl?$severUrl(cardData.coverImageUrl):$filterResDefault(cardData.classifyCode)"  alt="">
        <div class="bottom-box">
            <div class="bottom-label-box">
                <div class="course-time-label">{{cardData.creditHour||0}}课时</div>
                <el-tooltip class="item" effect="dark" :disabled="cardData.courseName.length<=9" :content="cardData.courseName" placement="top-start">
                    <p class="overflow bottom-title" style="flex: 1;margin-left: 1rem;">{{ cardData.courseName }}</p>
                </el-tooltip>
                </div>
            <div class="number-box" v-if="!hidePerson">
                <div>
                    <el-tooltip class="item" effect="dark" content="学习人数" placement="top-start">
                        <img class="rs" src="../../../assets/image/operation/rs.png" alt="">
                    </el-tooltip>
                    <div class="number-num">{{ cardData.studyCount||0 }}</div>
                </div>
                <div>
                    <el-tooltip class="item" effect="dark" content="学习次数" placement="top-start">
                        <img class="cs" src="../../../assets/image/operation/cs.png" alt="">
                    </el-tooltip>
                    <div class="number-num">{{ cardData.studyNumberCount||0 }}</div>
                </div>
                <div>
                    <el-tooltip class="item" effect="dark" content="收藏数" placement="top-start">
                        <img class="dz" src="../../../assets/image/operation/dz.png" alt="">
                    </el-tooltip>
                    <div class="number-num">{{ cardData.collectCount||0 }}</div>
                </div>
            </div>
            <div v-else class="progress">
                <el-progress :percentage="parseInt(this.cardData.completenessTeachingUnitCount/this.cardData.teachingUnitCount*100)"></el-progress>
            </div>
        </div>
    </div>
</template>

<script>
import { filterStatus } from '@/utils/utils';
    export default {
       props:['cardData','width','dropdown','publish','hidePerson'],
       methods:{
        filterStatus,
        edit(){
            this.$emit('edit');
        },
        del(){
            this.$emit('del');
        },
        toDetail(){
            this.$emit('to_detail')
        },
       },
    }
</script>

<style lang="less" scoped>
.card-box:hover{
    transform: translateY(-1rem);
}
.card-box{
    border: 1px solid #ebeef5;
    display: inline-block;
    position: relative;
    width: 24rem;
    cursor: pointer;
    transition: all 0.3s;
    border-radius: 1rem;
    min-width: 240px;
    .bg{
        width: 100%;
        aspect-ratio: var(--aspectRatio);
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 1rem;
        .operation-content{
            position: absolute;
            right: 1rem;
            top: 1rem;
            display: flex;
            align-items: center;
            &> :nth-child(n){
                width: 16px;
                height: 16px;
                border-radius: 0.2rem;
                background-color: rgba(0, 0, 0,0.5);
                margin-left: 0.8rem;
                display: flex;
                align-items: center;
                justify-content: center;
                img{
                    width: 1rem;
                    height: auto;
                    object-fit: cover;
                }
            }
        }
    }
    .better-more{
        width: 16px;
        height: 16px;
        border-radius: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .icon-gengduo1{
        color: black;
        font-size: 2.5rem;
        cursor: pointer;
    }
    .dropdown{
        position: absolute;
        top: 0;
        right: 1rem;
    }

}
.img-style{
    width: 100%;
    aspect-ratio: var(--aspectRatio);
    object-fit: cover;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
}
.bottom-box{
    background-color: #ffffff;
    padding: 1.5rem 0;
    .bottom-label-box{
        display: flex;
        align-items: center;
        margin: 0 1.5rem;
    }
    .bottom-title{
        color: #334681;
        font-weight: 700;
        font-size: 16px;
    }
    .number-box{
        display: flex;
        align-items: center;
        color: #334681;
        padding: 1.5rem 1.5rem 0 1.5rem;
        justify-content: space-between;
        i{
            color: #0067FF;
            font-weight: 700;
        }
        &> :nth-child(1){
            color: #ffffff;
            padding:1px 3px;
        }
        &> :nth-child(n){
            display: flex;
            align-items: center;
        }
    }
}
.no-start-label{
    // width: 48px;
    padding: 0.7rem 1rem;
    height: 2.4rem;
    color: #ffffff;
    border-radius: 1rem 0px 1rem 0px;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
.course-time-label{
    background: linear-gradient(0deg,#72bbff 0%, #387dff 100%);
    border-radius: 0.8rem 0px 0px 0px;
    color: #ffffff;
    font-size: 12px;
    font-weight: 400;
    padding: 0.2rem 0.5rem;
}
.number-num{
    margin-left: 3px;
    color: #334681;
    font-weight: 700;
    margin-left: 0.5rem;
}
.progress{
    padding: 1rem 1.5rem 0 1.5rem;
}
@media screen and (max-width:750px){
    .card-box{
        width: 100% !important;
    }
    .no-start-label{
        padding: 1.7rem 1rem;
    }
}
</style>